import { resolveTenantSlugFromAdminEmail } from "../../tenant/platform-domain";

/**
 * Déduit le slug tenant IAM à partir de l'email de connexion.
 * @see buildTenantAdminLoginEmail — admin@{slug}.itaas-suite.com
 */
export function resolveTenantSlugFromEmail(
  email: string,
  fallback = "demo",
): string {
  return resolveTenantSlugFromAdminEmail(email) ?? fallback;
}
